import type { Metric } from "web-vitals";

const endpoint = import.meta.env.VITE_WEB_VITALS_ENDPOINT;

function buildPayload(metric: Metric) {
  const { name, value, id, delta, rating, entries, navigationType } = metric;
  return {
    id,
    name,
    value,
    delta,
    rating,
    navigationType,
    page: window.location.pathname,
    href: window.location.href,
    timestamp: Date.now(),
    entries: entries?.map((entry) => {
      return {
        name: entry.name,
        startTime: entry.startTime,
        duration: entry.duration,
        entryType: entry.entryType,
      };
    }),
  };
}

function logMetric(metric: Metric) {
  if (import.meta.env.DEV) {
    console.info(
      `[web-vitals] ${metric.name} (${metric.rating})`,
      Math.round(metric.value * 100) / 100,
      metric,
    );
  }
}

/**
 * Default reporter that logs metrics locally and optionally POSTs them
 * to the configured analytics endpoint.
 */
export function sendWebVitals(metric: Metric) {
  if (!endpoint) {
    logMetric(metric);
    return;
  }

  const body = JSON.stringify(buildPayload(metric));

  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: "application/json" });
    navigator.sendBeacon(endpoint, blob);
    return;
  }

  fetch(endpoint, {
    method: "POST",
    body,
    keepalive: true,
    headers: {
      "Content-Type": "application/json",
    },
  }).catch((error) => {
    if (import.meta.env.DEV) {
      console.warn("[web-vitals] failed to send metric", error);
    }
  });
}
